import React from 'react'
import styled from 'styled-components'
import Logo from '../../assets/icons/logo.svg'
import {Icon, IconName} from '../../components/library/icon/icon'
import {
  fontMedium,
  fontSmall
} from '../../views/action-flow/components/library/css'

export const AuthButtonGroup = styled.div`
  margin: 10px 0 20px;
`

const StyledMedia = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({theme}) => theme.grey05};
  border-radius: ${({theme}) => theme.borderRadiusPill};
  margin-bottom: 30px;
  align-self: center;
`

export const AuthLargeHeader = styled.h1`
  font-size: ${p => p.theme.fontSizeXL};
  text-align: center;
  margin: 20px 0 0;
`

export const AuthSmallHeader = styled.h3`
  font-size: ${p => p.theme.fontSizeL};
  text-align: center;
  margin: 0;
`
export const AuthButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const AuthMessage = styled.p`
  ${fontMedium}
  text-align: center;
  color: ${({theme}) => theme.colors.grey11};
  margin: 20px 0;
`

export const Error = styled.div<{margin?: string}>`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.theme.red};
  border-radius: ${p => p.theme.borderRadius};
  padding: 10px 20px;
  align-self: stretch;
  margin: ${p => (p.margin ? p.margin : '0 0 10px')};
  background: ${p => p.theme.redLightest};
  ${fontSmall}
`

interface AuthMediaProps {
  icon: IconName
}

export const AuthMedia = ({icon}: AuthMediaProps) => (
  <StyledMedia>
    <Icon name={icon} />
  </StyledMedia>
)

export const AuthLogo = () => <Logo />
